import { useNavigate, useLocation } from "react-router-dom";
import { BrandificationImageFallback } from "../../components";
import { IconTopAngle } from "../../containers/MainLayout/icons";
import React, { useState, useEffect } from "react";
import { makeOppositeShade } from "../../utils/colorService";
import {
  getFallbackImageFromUrl,
  getImageFromUrl,
  getTouchPointImage,
  getTouchPointImageRegular,
} from "../../utils/imageService";
import LoginSwitch from "../LoginSwitch";
import Notifications from "../Notifications";
import AddTPButton from "../../components/svgs/AddTPButton";
import { Link } from "react-router-dom";
import "./styles.scss";

const ClientHeader = props => {
  const { client, showFeeds, showLogins, profile } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const [, setWindowWidth] = useState(window.innerWidth);
  const isPdf = new URLSearchParams(location.search).get("isPDF") === "true";

  const noHeaderRoutes = ["/survey", "/quiz", "/orga-board", "/community", "/profile"];

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (
    window.innerWidth < 1100 &&
    (noHeaderRoutes.indexOf(location.pathname) > -1 ||
      location.pathname.startsWith("/touchpoint") ||
      location.pathname.startsWith("/card") ||
      location.pathname.startsWith("/milestone") ||
      location.pathname.startsWith("/audit") ||
      location.pathname.startsWith("/tp-survey"))
  ) {
    return null;
  }
  if (isPdf) {
    return null;
  }
  return (
    <div className="client-header">
      <div className="client-header-brand">
        {window.innerWidth < 1100 ? (
          <div className="client-header-brand">
            <div className="logo-outter-circle">
              <div className="logo-inner-circle">
                <BrandificationImageFallback
                  src={getTouchPointImage(client)}
                  fallbackImage={getTouchPointImageRegular(client)}
                  className="logo"
                />
              </div>
            </div>
            <div>
              <div className="project-name">{client?.title}</div>
              <div className="project-desc ">{client?.description}</div>
            </div>
            <div className="client-header-mobile-details">
              {client && showFeeds && <Notifications />}
              {showLogins && <LoginSwitch />}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <Link to="/touchpoint/new" className="add-new-point mobile-only">
        <AddTPButton color={client?.secondaryColor} color2={makeOppositeShade(client?.bgColor)} />
      </Link>
      {window.innerWidth > 1100 ? (
        <div className="client-header-details">
          {showLogins && <LoginSwitch />}
          {client && showFeeds && <Notifications />}
          <div className="client-profile mr-3 pointer">
            <BrandificationImageFallback
              onClick={() => navigate(`/profile`)}
              src={getImageFromUrl(profile?.photoURL)}
              fallbackImage={getFallbackImageFromUrl(profile?.photoURL)}
              className={`${profile?.photoURL ? "" : "no-image"}`}
            />
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="topAngle">
        <IconTopAngle />
      </div>
    </div>
  );
};

export default ClientHeader;
